import { API_CONNECTED_OBJECT, API_FEATURE_LIST, BASE_ADMIN, BASE_API } from "../constants/api";
import { FeatureType } from "../types/feature";
import useRequest from "./useRequest";
import { UserRole } from "../types/user";
import { isSdiAdmin } from "../utils/roles";
import useAuth from "./useAuth";

type FeaturesResponse = {
  features: FeatureType[];
  objName: string;
}

const useFeatures = () => {
  const {user} = useAuth();
  const {
    error, isLoading, request, response
  } = useRequest<FeaturesResponse>();

  const getFeatures = (objID: number) => {
    if (isSdiAdmin(user?.role) || user?.role === UserRole.site_admin) {
      request(BASE_ADMIN, `${API_CONNECTED_OBJECT}/${objID}/${API_FEATURE_LIST}`, {secure: true})
    } else {
      request(BASE_API, `${API_CONNECTED_OBJECT}/${objID}/${API_FEATURE_LIST}`, {secure: true})
    }
  }

  return {error, isLoading, getFeatures, data: response?.features ?? null, objName: response?.objName || '' }
}

export default useFeatures;